import type { AvatarItem } from '../types/types';

export const availableItems: AvatarItem[] = [  
  { 
    id: 'skin_default', 
    src: '/body/boneco.png', 
    x: 200, y: 250, zIndex: 0, 
    category: 'skin',
    title: 'Padrão',
    scale: 1,
    skinColor: '#f67e57' 
  },
  { 
    id: 'skin_claro', 
    src: '/body/Avatar_pardo.png', 
    x: 200, y: 250, zIndex: 0, 
    category: 'skin',
    title: 'Tom Claro',
    scale: 1,
    skinColor: '#8b5a42' 
  },
  { 
    id: 'skin_rosado', 
    src: '/body/Avatar_branco.png', 
    x: 200, y: 250, zIndex: 0, 
    category: 'skin',
    title: 'Tom Rosado',
    scale: 1,
    skinColor: '#f4a688' 
  },
  { 
    id: 'skin_bege', 
    src: '/body/Avatar_amarelo.png', 
    x: 200, y: 250, zIndex: 0, 
    category: 'skin',
    title: 'Tom Bege',
    scale: 1,
    skinColor: '#e8b894' 
  },
];

export const initialAvatarState: AvatarItem[] = [
  { 
    id: 'boneco_base', 
    src: '/body/boneco.png', 
    x: 200, 
    y: 250, 
    zIndex: 0, 
    category: 'base',
    scale: 1
  },
];
